// eslint-disable-next-line import/no-cycle
import Callout from './Callout';

export default Callout;
